<template>
  <div class="chart-container">
    <div class="Hcp-main-header">
      <div class="main-header-left">
        <span>{{$t('DeviceSetting')}}</span>
      </div>
      <div class="main-header-right">
        <!-- <button @click="print2"><span>test</span></button> -->
        <button @click="print"><span>{{$t('print')}}</span></button>
        <button class="set" @click="open"><span>{{$t('set')}}</span></button>
        <p><span class="time">{{time}}</span></p>
      </div>
    </div>
    <hr class="small-hr spe-hr">

    <div class="part" v-if="showEasyPatch !=='easysense'">
      <div class="tit1e">
        <!--<img src="../../assets/chart6-icon/Basal.png">-->
        <span>&nbsp;{{$t('basal')}}</span>
      </div>
      <!-- <hr class="small-hr spe-hr">
      <div class="label labe2">
        <span>{{$t('Insulin Pump')}}: <label>{{userset.pump_module_flag}}</label></span>
        <span>{{$t('pumpSN')}}: <label>{{userset.pump_sn}}</label></span>
        <span>{{$t('MaxBasalRate')}}: <label>{{basal.max_rate}}</label></span>
        <span>{{$t('BasalPatterns')}}: <label>{{basal.basal_onoff}}</label></span>
        <span class="spe-span2">{{$t('Selected Basal Pattern')}}: <label>{{basal.basal_select}}</label></span>
      </div>-->
      <br/>
      <table class="statics-table">
        <tr>
          <td class="td3">{{$t('MaxBasalRate')}}: {{basal.max_rate}} <!--{{$t('basal_unit2')}}--></td>
          <td class="td3">{{$t('Selected Basal Pattern')}}: {{basal.basal_select}}</td>
          <td>{{$t('BasalPatterns')}}: {{basal.basal_onoff}}</td>
        </tr>
      </table>
      <br/><br/>
      <div id="chart6_1" class="graph" ></div>
      <div id="chart6_2" class="graph" :element-loading-text="loadingText"  v-loading="loading"></div>
      <div id="chart6_3" class="graph" ></div>
      <div id="chart6_4" class="graph" ></div>
      <div id="chart6_5" class="graph" ></div>
      <!--<div v-show="moreBasal" class="more-basal">

      </div>-->

      <div v-show="moreBasal">

      <div id="chart6_6" class="graph"></div>
      <div id="chart6_7" class="graph"></div>
      <div id="chart6_8" class="graph" ></div>

      </div>

      <div v-for="item in this.basalInfo">
        <div class="statics">
          <p class="custom">{{item.title}}</p>
          <span style="float: right;margin-right: 30px;">{{$t('24h Total')}}: {{item.total}}{{$t('ins_unit2')}}</span>
          <table class="statics-table">
            <tr>
              <td class="td1">{{$t('Start')}}</td><td v-for="i in item.bsg1" class="td1">{{i[0]}}</td>
            </tr>
            <tr>
              <td class="td3">{{$t('basal_unit2')}}</td><td v-for="i in item.bsg1" class="td3">{{i[1]}}</td>
            </tr>
          </table>
        </div>
        <div class="statics" v-show="(item.bsg2show)">
          <table class="statics-table">
            <tr>
              <td class="td1">{{$t('Start')}}</td><td v-for="i in item.bsg2" class="td1">{{i[0]}}</td>
            </tr>
            <tr>
              <td class="td3">{{$t('basal_unit2')}}</td><td v-for="i in item.bsg2" class="td3">{{i[1]}}</td>
            </tr>
          </table>
        </div>
        <div class="statics" v-show="(item.bsg3show)">
          <table class="statics-table">
            <tr>
              <td class="td1">{{$t('Start')}}</td><td v-for="i in item.bsg3" class="td1">{{i[0]}}</td>
            </tr>
            <tr>
              <td class="td3">{{$t('basal_unit2')}}</td><td v-for="i in item.bsg3" class="td3">{{i[1]}}</td>
            </tr>
          </table>
        </div>
        <div class="statics" v-show="(item.bsg4show)">
          <table class="statics-table">
            <tr>
              <td class="td1">{{$t('Start')}}</td><td v-for="i in item.bsg4" class="td1">{{i[0]}}</td>
            </tr>
            <tr>
              <td class="td3">{{$t('basal_unit2')}}</td><td v-for="i in item.bsg4" class="td3">{{i[1]}}</td>
            </tr>
          </table>
        </div>
      </div>

    </div>

    <div class="part" v-if="showEasyPatch !=='easysense'">
      <div class="tit1e">
        <!--<img src="../../assets/chart6-icon/Bolus.png">-->
        <span>&nbsp; {{$t('bolus')}}</span>
      </div>

      <div v-if="showEasyPatch==='PDM'" class="statics" style="margin-top: 30px;">
        <!--<p>{{$t('bolus')}}</p>-->
        <table class="statics-table">
          <tr>
            <td class="td1">{{$t('Maximum Bolus')}}: {{bolus.max_bolus}} <!--{{$t('ins_unit2')}}--></td>
            <td class="td1">{{$t('Bolus Increment')}}: {{bolus.bolus_step}} <!--{{$t('ins_unit2')}}--></td>
            <td class="td2">{{$t('Bolus Calculator')}}: {{bolus.bolus_wizard}}</td>
          </tr>
          <tr>
            <td class="td3">{{$t('Combo/Ext Bolus')}}: {{bolus.extent_option}}</td>
            <td class="td3">{{$t('BG Reminder')}}: {{bolus.bg_reminder}}</td>
            <td>{{$t('Active Insulin Time')}}: {{bolus.ins_active_time}} </td>
          </tr>
        </table>
      </div>

      <div v-else class="statics" style="margin-top: 30px;">
        <!--<p>{{$t('bolus')}}</p>-->
        <table class="statics-table">
          <tr>
            <td class="td3">{{$t('Maximum Bolus')}}: {{bolus.max_bolus}} <!--{{$t('ins_unit2')}}--></td>
            <td class="td3">{{$t('Bolus Calculator')}}: {{bolus.bolus_wizard}}</td>
            <td>{{$t('Active Insulin Time')}}: {{bolus.ins_active_time}} </td>
          </tr>
          <!--<tr>
            <td class="td3">{{$t('Combo/Ext Bolus')}}: {{bolus.extent_option}}</td>
            <td class="td3">{{$t('BG Reminder')}}: {{bolus.bg_reminder}}</td>
            <td>{{$t('Active Insulin Time')}}: {{bolus.ins_active_time}} </td>
          </tr>-->
        </table>
      </div>

      <div class="statics">
        <p class="custom">{{$t('IC Ratios')}}(g/{{$t('ins_unit2')}})</p>
        <table class="statics-table">
          <tr>
            <td class="td1">{{$t('Start')}}</td><td class="td1" v-for="i in IcRatio">{{i[0]}}</td><td class="td1">--</td><td class="td1">--</td><td class="td2">--</td>
          </tr>
          <tr>
            <td class="td3">{{$t('carbs')}}</td><td class="td3" v-for="i in IcRatio">{{i[1]}}</td><td class="td3">--</td><td class="td3">--</td><td>--</td>
          </tr>
        </table>
      </div>
      <div class="statics">
        <p class="custom">{{$t('Insulin Sensitivity')}} {{unit}}</p>
        <table class="statics-table">
          <tr>
            <td class="td1">{{$t('Start')}}</td><td v-for="i in ins_sen" class="td1">{{i[0]}}</td><td class="td1">--</td><td class="td1">--</td><td class="td2">--</td>
          </tr>
          <tr>
            <td class="td3">{{$t('BG')}}</td><td v-for="i in ins_sen" class="td3">{{i[1]}}</td><td class="td3">--</td><td class="td3">--</td><td>--</td>
          </tr>
        </table>
      </div>
      <div class="statics">
        <p class="custom">{{$t('BG Target')}}</p>
        <table class="statics-table">
          <tr>
            <td class="td1">{{$t('From')}}</td><td v-for="i in bg_target" class="td1">{{i[0]}}</td><td class="td1">--</td><td class="td1">--</td><td class="td2">--</td>
          </tr>
          <tr>
            <td class="td3">{{$t('Range')}}</td><td v-for="i in bg_target" class="td3">{{i[1]}}</td><td class="td3">--</td><td class="td3">--</td><td>--</td>
          </tr>
        </table>
      </div>
      <div class="statics">
        <p class="custom">{{$t('Bolus Reminder')}} {{maxBolOption}}</p>
        <table class="statics-table">
          <tr>
            <td class="td1">{{$t('From')}}</td>
            <td v-for="i in bolus_rem" class="td1">{{i[0]}}</td>
            <td class="td1" v-if="bolus_rem.length<3">--</td>
            <td class="td1" v-if="bolus_rem.length<2">--</td>
            <td class="td2" v-if="bolus_rem.length<1">--</td>
          </tr>
          <tr>
            <td class="td3">{{$t('To')}}</td>
            <td v-for="i in bolus_rem" class="td3">{{i[1]}}</td>
            <td class="td3" v-if="bolus_rem.length<3">--</td>
            <td class="td3" v-if="bolus_rem.length<2">--</td>
            <td v-if="bolus_rem.length<1">--</td>
          </tr>
        </table>
      </div>
    </div>

    <!-- 是PDM的设置还是 EasyPatch的设置 -->
    <div v-if="showEasyPatch ==='PDM'">
      <div class="part part1">
        <div class="tit1e">
          <span>&nbsp;{{$t('pdm')}}</span>
        </div>

        <div class="statics" style="margin-top: 30px;">
          <!--<p>{{$t('pdm')}}</p>-->
          <table class="statics-table">
            <tr>
              <td class="td1">{{$t('Audio Options')}}: {{userset.alarm_type}}</td>
              <td class="td1">{{$t('Patch Expiration')}}:{{userset.patch_expire_alarm}}</td>
              <td class="td2">{{$t('Sensor Expiration')}}: {{userset.sensor_expire_option}}</td>
            </tr>
            <tr>
              <td class="td1">{{$t('Low Reservoir')}}: {{userset.low_reservoir_time}}</td>
              <td class="td1">{{$t('Auto Off')}}: {{userset.auto_off_option}}</td>
              <td class="td2">{{$t('Confidence Reminder')}}: {{userset.cmd_response}}</td>
            </tr>
            <tr>
              <td class="td1">{{$t('Hourly Max')}}: {{userset.hour_bolus_max}}{{$t('ins_unit2')}}</td>
              <td class="td1">{{$t('Daily Max')}}: {{userset.day_bolus_max}}{{$t('ins_unit2')}}</td>
              <td class="td2">{{$t('Low Suspend')}}: {{userset.suspend_on_lowbg_option}}</td>
            </tr>
            <tr>
              <td class="td3">{{$t('Predictive Low Suspend')}}: {{userset.pre_suspend_on_lowbg_option}}</td>
              <td class="td3">{{$t('t1102_Out_of_Range')}}: {{userset.out_of_range_option}} </td>
              <td class="td3">{{$t('t1029_Auto_Mode_Feature')}}: {{userset.auto_basal.autobasalflag}} </td>

            </tr>
          </table>
        </div>
        <div class="statics" style="margin-top: 20px;">
          <table class="statics-table">
            <tr>
              <td class="td1">{{$t('Time Format')}}: {{userset.time_style}}</td>
              <td class="td1">{{$t('uername')}}: {{userset.user_name}}</td>
              <td class="td2">{{$t('Dispay Settings (Screen)')}}: {{userset.screen_timeout}}{{$t('Sec')}}</td>
            </tr>
            <tr>
              <td class="td1">{{$t('Dispay Settings (Backlight)')}}: {{userset.screen_timeout}}{{$t('Sec')}}</td>
              <td class="td1">{{$t('Device Options（CGM System)')}}: {{userset.cgms_module_flag}}</td>
              <td class="td2">{{$t('Device Options（Insulin Pump)')}}: {{userset.pump_module_flag}}</td>
            </tr>
            <tr>
              <td class="td3">{{$t('Glucose Unit')}}: {{userset.glucose_unit}}</td>
              <td class="td3">{{$t('Alarm Clock')}} : {{userset.clock_option}}</td>
              <td>{{$t('Telephone')}}: {{userset.telephone}}</td>
            </tr>
          </table>
        </div>
        <div class="statics">
          <p class="custom">{{$t('Alarm Clock')}} ({{userset.clock_option}})</p>
          <table class="statics-table">
            <tr>
              <td class="td1">{{$t('time')}}</td>
              <td v-for="i in userset.clock" class="td1">{{i[0]}}</td>
              <td class="td1">--</td>
              <td class="td1">--</td>
              <td class="td2">--</td>
            </tr>
            <tr>
              <td class="td3">{{$t('Repeat')}}</td><td v-for="i in userset.clock" class="td3">{{i[1]}}</td><td class="td3">--</td><td class="td3">--</td><td>--</td>
            </tr>
          </table>
        </div>
      </div>


      <div class="part">
        <div class="tit1e">
          <span>&nbsp;{{$t('CGM')}}</span>
        </div>

        <div class="statics" style="margin-top: 30px;">
          <!--<p style="float: left">{{$t('CGM')}}</p>-->
          <div class="spe-text">
            <p>{{$t('Glucose Alerts')}}:  {{cgm.sensor_alarm_option}}</p>
            <p>{{$t('Alert Silence')}}:  {{cgm.alarm_silent_option}}</p>
          </div>
          <div class="statics" style="clear: both">
            <p class="custom">{{$t('Glucose Limits')}}</p>
            <table class="statics-table">
              <tr>
                <td class="td1">{{$t('From')}}</td><td v-for="i in cgmLimit" class="td1">{{i[0]}}</td><td class="td1">--</td><td class="td1">--</td><td class="td2">--</td>
              </tr>
              <tr>
                <td class="td1">{{$t('Low')}}</td><td v-for="i in cgmLimit" class="td1">{{i[1]}}</td><td class="td1">--</td><td class="td1">--</td><td class="td2">--</td>
              </tr>
              <tr>
                <td class="td3">{{$t('High')}}</td><td v-for="i in cgmLimit" class="td3">{{i[2]}}</td><td class="td3">--</td><td class="td3">--</td><td>--</td>
              </tr>
            </table>
          </div>
        </div>
        <div class="statics small-table">
          <p class="custom" style="float: left">{{$t('Predicitive Alerts')}} (hh:mm)</p>
          <table class="statics-table">
            <tr>
              <td class="td1">{{$t('high1')}}</td><td class="td1">{{cgm.sensor_forecast_alarm.high[0]}}</td><td class="td2">{{cgm.sensor_forecast_alarm.high[1]}}</td>
            </tr>
            <tr>
              <td class="td3">{{$t('low1')}}</td><td class="td3">{{cgm.sensor_forecast_alarm.low[0]}}</td><td>{{cgm.sensor_forecast_alarm.low[1]}}</td>
            </tr>
          </table>
        </div>
        <div class="statics small-table">
          <p class="custom" style="float: left">{{$t('Rate Alerts')}} ({{unit1}}/min)</p>
          <table class="statics-table">
            <tr>
              <td class="td1">{{$t('Rise')}}</td><td class="td1">{{cgm.sensor_rate_alarm.rise[0]}}</td><td class="td2">{{cgm.sensor_rate_alarm.rise[1]}}</td>
            </tr>
            <tr>
              <td class="td3">{{$t('Fall')}}</td><td class="td3">{{cgm.sensor_rate_alarm.fall[0]}}</td><td>{{cgm.sensor_rate_alarm.fall[1]}}</td>
            </tr>
          </table>
        </div>
        <div class="statics small-table">
          <p class="custom" style="float: left">{{$t('Snooze')}} (hh:mm)</p>
          <table class="statics-table">
            <tr>
              <td class="td1">{{$t('high1')}}</td><td class="td1">{{cgm.sensor_alarm_repeat.high[0]}}</td><td class="td2">{{cgm.sensor_alarm_repeat.high[1]}}</td>
            </tr>
            <tr>
              <td class="td3">{{$t('low1')}}</td><td class="td3">{{cgm.sensor_alarm_repeat.low[0]}}</td><td>{{cgm.sensor_alarm_repeat.low[1]}}</td>
            </tr>
          </table>
        </div>
        <div class="statics middle-table">
          <p class="custom" style="float: left">{{$t('calib')}}</p>
          <table class="statics-table">
            <tr>
              <td class="td1">{{$t('Calibration Reminder')}}</td><td class="td1">{{cgm.sensor_alarm_settings.calib_remind_option}}</td>
              <td class="td2">{{cgm.sensor_alarm_settings.calib_remind_time}}</td>
            </tr>
            <tr>
              <td class="td1">{{$t('Calibration Repeat')}}</td><td class="td1">{{cgm.sensor_alarm_settings.calib_remind_interval}}</td><td></td>
            </tr>
            <tr>
              <td class="td3">{{$t('Graph Range')}}</td><td class="td3">{{cgm.sensor_alarm_settings.trend_time_scope}}H</td><td></td>
            </tr>
          </table>
        </div>
        <div style="clear: both"></div>
      </div>


      <div class="part">
        <div class="tit1e">
          <span>&nbsp;{{$t('t1222_Auto_Mode')}}</span>
        </div>

        <div class="statics" style="margin-top: 30px;">
          <!--<p style="float: left">{{$t('CGM')}}</p>-->
          <div class="spe-text">
            <p>{{$t('t1222_Auto_Mode')}}:  {{userset.auto_basal.autobasalflag}}</p>

          </div>
          <div class="statics" style="clear: both">

            <table class="statics-table">
              <tr>
                <td class="td1">{{$t('t1029_Target_SG')}}: {{userset.auto_basal.BGTarget}}</td>

                <td class="td1">{{$t('t1029_Auto_Meal_Handling')}}: {{userset.auto_basal.nFoodFlag}}</td>

                <td class="td1">{{$t('weight')}}: {{userset.auto_basal.AutoBasalWeight===0 ?'--':userset.auto_basal.AutoBasalWeight+'kg'}} </td>
              </tr>

              <tr>
                <td class="td3">{{$t('t1029_Total_Daily_Dose')}}: {{userset.auto_basal.AutoBasalTDD===0 ?'--':userset.auto_basal.AutoBasalTDD+'U'}} </td>

                <td class="td3"></td>
                <td class="td3"></td>
              </tr>
            </table>
          </div>
        </div>

      </div>

    </div>

    <!-- EasyPatch -->
    <div v-if="showEasyPatch==='easypatch'">
      <div class="part part1">
        <div class="tit1e">
          <span>&nbsp;{{$t('Pump')}}</span>
        </div>

        <div class="statics" style="margin-top: 30px;">
          <!--<p>{{$t('pdm')}}</p>-->
          <table class="statics-table">
            <tr>
              <td class="td1">{{$t('t1108_Pump_Bash_SN')}}: {{pumpSN}}</td>
              <td class="td1">{{$t('Patch Expiration')}}:{{userset.patch_expire_alarm}}</td>
              <td class="td2">{{$t('Low Reservoir')}}: {{userset.low_reservoir_time}}</td>
            </tr>
            <tr>
              <td class="td1">{{$t('t1102_Out_of_Range')}}: {{userset.out_of_range_option}}</td>
              <td class="td1">{{$t('t1102_Command_Reminder')}}: {{userset.cmd_response}}</td>
              <td class="td2">{{$t('Auto Off')}}: {{userset.auto_off_option}}</td>
            </tr>
            <tr>
              <td class="td3">{{$t('Daily Max')}}: {{userset.day_bolus_max}}{{$t('ins_unit2')}}</td>
              <td class="td3">{{$t('Hourly Max')}}: {{userset.hour_bolus_max}}{{$t('ins_unit2')}}</td>
              <td class=""></td>
            </tr>
          </table>
        </div>

        <div class="small-table-wrap">
          <div class="statics small-table">
            <p class="custom" style="float: left">{{$t('t1102_Alarms_Alerts_on_APP')}} </p>
            <table class="statics-table">
              <tr>
                <td class="td1">{{$t('t1112_Audio')}}</td>
                <td class="td2">{{$t(userset.pump_alarm_audio_option)}}</td>
              </tr>

              <tr>
                <td class="td1">{{$t('Vibrate')}}</td>
                <td class="td2">{{$t(userset.pump_alarm_vibrate_option)}}</td>

              </tr>

              <tr>
                <td class="td3">{{$t('t1029_Pump_Light')}}</td>
                <td class="">{{$t(userset.easypatch_pump_light)}}</td>
              </tr>


            </table>
          </div>
          <div class="statics small-table">
            <p class="custom" style="float: left">{{$t('t1102_Alarms_on_App')}}</p>
            <table class="statics-table">
              <tr>
                <td class="td1">{{$t('Repeat')}}</td>
                <td class="td2">{{userset.easypatch_pump_alarm_repeat}}</td>
              </tr>
              <tr>
                <td class="td1">{{$t('Snooze')}}</td>
                <td class="td2">{{userset.easypatch_pump_alarm_snooze}}</td>
              </tr>
              <tr>
                <td class="td3">{{$t('t1112_Tone')}}</td>
                <td>{{userset.easypatch_pump_alarm_tone.split('.')[0]}}</td>
              </tr>
            </table>
          </div>
          <div class="statics small-table">
            <p class="custom" style="float: left">{{$t('t1102_Alerts_on_App')}}</p>
            <table class="statics-table">
              <tr>
                <td class="td1">{{$t('Repeat')}}</td>
                <td class="td2">{{userset.easypatch_pump_alert_repeat}}</td>
              </tr>
              <tr>
                <td class="td1">{{$t('Snooze')}}</td>
                <td class="td2">{{userset.easypatch_pump_alert_snooze}}</td>
              </tr>
              <tr>
                <td class="td3">{{$t('t1112_Tone')}}</td>
                <td>{{userset.easypatch_pump_alert_tone.split('.')[0]}}</td>
              </tr>
            </table>
          </div>
          <div style="clear: both;"></div>
        </div>
      </div>

      <div class="part">
        <div class="tit1e">
          <span>&nbsp;{{$t('CGM')}}</span>
        </div>

        <div class="statics" style="margin-top: 30px;">

          <!--<div class="spe-text">
            <p>{{$t('Glucose Alerts')}}:  {{cgm.sensor_alarm_option}}</p>
            <p>{{$t('Alert Silence')}}:  {{cgm.alarm_silent_option}}</p>
          </div>-->

          <div class="statics" style="margin-top: 30px;">
            <!--<p>{{$t('pdm')}}</p>-->
            <table class="statics-table">
              <tr>
                <td class="td1">{{$t('t1108_Transmitter_SN')}}: {{tranSN}}</td>
                <td class="td1">{{$t('Sensor Expiration')}}:{{userset.sensor_expire_option}}</td>
                <td class="td2">{{$t('Glucose Alerts')}}: {{cgm.sensor_alarm_option}}</td>
              </tr>
              <tr>
                <td class="td3">{{$t('t1102_Factory_Calibration')}}: {{$t(userset.factory_calibration_option)}}</td>
                <td class="td3"></td>
                <td class="td3"></td>
              </tr>
            </table>
          </div>

          <div class="statics" style="clear: both">
            <p class="custom">{{$t('Glucose Limits')}}</p>
            <table class="statics-table">
              <tr>
                <td class="td1">{{$t('From')}}</td><td v-for="i in cgmLimit" class="td1">{{i[0]}}</td><td class="td1">--</td><td class="td1">--</td><td class="td2">--</td>
              </tr>
              <tr>
                <td class="td1">{{$t('Low')}}</td><td v-for="i in cgmLimit" class="td1">{{i[1]}}</td><td class="td1">--</td><td class="td1">--</td><td class="td2">--</td>
              </tr>
              <tr>
                <td class="td3">{{$t('High')}}</td><td v-for="i in cgmLimit" class="td3">{{i[2]}}</td><td class="td3">--</td><td class="td3">--</td><td>--</td>
              </tr>
            </table>
          </div>
        </div>
        <div class="table-group-wrap1">
          <div class="statics small-table">
            <p class="custom" style="float: left">{{$t('Predicitive Alerts')}} (hh:mm)</p>
            <table class="statics-table">
              <tr>
                <td class="td1">{{$t('high1')}}</td>
                <td class="td1">{{cgm.sensor_forecast_alarm.high[0]}}</td>
                <td class="td2">{{cgm.sensor_forecast_alarm.high[1]}}</td>
              </tr>
              <tr>
                <td class="td3">{{$t('low1')}}</td>
                <td class="td3">{{cgm.sensor_forecast_alarm.low[0]}}</td>
                <td>{{cgm.sensor_forecast_alarm.low[1]}}</td>
              </tr>
            </table>
          </div>
          <div class="statics small-table">
            <p class="custom" style="float: left">{{$t('Rate Alerts')}} ({{unit1}}/min)</p>
            <table class="statics-table">
              <tr>
                <td class="td1">{{$t('Rise')}}</td>
                <td class="td1">{{cgm.sensor_rate_alarm.rise[0]}}</td>
                <td class="td2">{{cgm.sensor_rate_alarm.rise[1]}}</td>
              </tr>
              <tr>
                <td class="td3">{{$t('Fall')}}</td>
                <td class="td3">{{cgm.sensor_rate_alarm.fall[0]}}</td>
                <td>{{cgm.sensor_rate_alarm.fall[1]}}</td>
              </tr>
            </table>
          </div>
          <div style="clear:both;"></div>
        </div>

        <div class="table-group-wrap1">
          <div class="statics small-table">
            <p class="custom" style="float: left">{{$t('t1102_Alerts_for_Low')}} </p>
            <table class="statics-table">
              <tr>
                <td class="td1">{{$t('Repeat')}}</td>
                <td class="td2">{{cgm.easypatch_cgm_alerts_low_repeat}}</td>
              </tr>
              <tr>
                <td class="td1">{{$t('Snooze')}}</td>
                <td class="td2">{{cgm.easypatch_cgm_alerts_low_snooze}}</td>
              </tr>
              <tr>
                <td class="td3">{{$t('t1112_Tone')}}</td>
                <td>{{cgm.easypatch_cgm_alerts_low_tone}}</td>
              </tr>
            </table>
          </div>
          <div class="statics small-table">
            <p class="custom" style="float: left">{{$t('t1102_Alerts_for_High')}} </p>
            <table class="statics-table">
              <tr>
                <td class="td1">{{$t('Repeat')}}</td>
                <td class="td2">{{cgm.easypatch_cgm_alerts_high_repeat}}</td>
              </tr>
              <tr>
                <td class="td1">{{$t('Snooze')}}</td>
                <td class="td2">{{cgm.easypatch_cgm_alerts_high_snooze}}</td>
              </tr>
              <tr>
                <td class="td3">{{$t('t1112_Tone')}}</td>
                <td>{{cgm.easypatch_cgm_alerts_high_tone}}</td>
              </tr>
            </table>
          </div>
          <div class="statics small-table">
            <p class="custom" style="float: left">{{$t('t1102_Alerts_for_Others')}}</p>
            <table class="statics-table">
              <tr>
                <td class="td1">{{$t('Repeat')}}</td>
                <td class="td2">{{cgm.easypatch_cgm_alerts_other_repeat}}</td>
              </tr>
              <tr>
                <td class="td1">{{$t('Snooze')}}</td>
                <td class="td2">{{cgm.easypatch_cgm_alerts_other_snooze}}</td>
              </tr>
              <tr>
                <td class="td3">{{$t('t1112_Tone')}}</td>
                <td>{{cgm.easypatch_cgm_alerts_other_tone}}</td>
              </tr>
            </table>
          </div>

          <div class="statics small-table">
            <p class="custom" style="float: left">{{$t('t1029_Alerts_for_Hypo')}} </p>
            <table class="statics-table">
<!--              <tr>-->
<!--                <td class="td1">{{$t('Repeat')}}</td>-->
<!--                <td class="td2">{{cgm.easypatch_cgm_alerts_low_repeat}}</td>-->
<!--              </tr>-->
<!--              <tr>-->
<!--                <td class="td1">{{$t('Snooze')}}</td>-->
<!--                <td class="td2">{{cgm.easypatch_cgm_alerts_low_snooze}}</td>-->
<!--              </tr>-->
              <tr>
                <td class="td3">{{$t('t1112_Tone')}}</td>
                <td>{{cgm.easypatch_cgm_alerts_hypo_tone}}</td>
              </tr>
            </table>
          </div>

          <div style="clear:both;"></div>
        </div>
      </div>

      <div class="part">
        <div class="tit1e">
          <span>&nbsp;{{$t('APP')}}</span>
        </div>

        <div class="statics" style="margin-top: 30px;">

          <div class="statics" style="margin-top: 30px;">
            <!--<p>{{$t('pdm')}}</p>-->
            <table class="statics-table">
              <tr>
                <td class="td1">{{$t('Name')}}: {{userset.user_name}}</td>
                <td class="td1">{{$t('Audio Options')}}: {{userset.alarm_type}}</td>
                <td class="td2">{{$t('Glucose Unit')}}: {{userset.glucose_unit}}</td>
              </tr>
              <tr>
                <td class="td3">{{$t('t1112_Weight_Unit')}}: {{userset.easypatch_weight_unit}}</td>
                <td class="td3">{{$t('t1112_Height_Unit')}}: {{userset.easypatch_height_unit}}</td>
                <td class="td3"></td>
              </tr>
            </table>
          </div>

        </div>

      </div>

      <!-- 提醒设置 -->
      <!--
      <div class="part">
        <div class="tit1e">
          <span>&nbsp;{{$t('Reminders')}}</span>
        </div>

        <div class="statics" style="clear: both">

          <table class="statics-table">
            <tr>
              <td class="td1">{{$t('Title')}}</td><td v-for="i in easypatch_reminder" class="td1">{{i[0]}}</td><td class="td1">--</td><td class="td1">--</td><td class="td2">--</td>
            </tr>
            <tr>
              <td class="td1">{{$t('Type')}}</td><td v-for="i in easypatch_reminder" class="td1">{{i[1]}}</td><td class="td1">--</td><td class="td1">--</td><td class="td2">--</td>
            </tr>
            <tr>
              <td class="td1">{{$t('Time')}}</td><td v-for="i in easypatch_reminder" class="td1">{{i[1]}}</td><td class="td1">--</td><td class="td1">--</td><td class="td2">--</td>
            </tr>
            <tr>
              <td class="td3">{{$t('Repeat')}}</td><td v-for="i in easypatch_reminder" class="td3">{{i[2]}}</td><td class="td3">--</td><td class="td3">--</td><td>--</td>
            </tr>
          </table>
        </div>

      </div>-->

      <!-- EasyLoop -->
      <div class="part">
        <div class="tit1e">
          <span>&nbsp;{{$t('EasyLoop')}}</span>
        </div>

        <div class="statics" style="margin-top: 30px;">

          <div class="statics" style="margin-top: 30px;">
            <!--<p>{{$t('pdm')}}</p>-->
            <table class="statics-table">
              <tr>
                <td class="td3">{{$t('Low Suspend')}}: {{userset.suspend_on_lowbg_option}}</td>
                <td class="td3">{{$t('Predictive Low Suspend')}}:  {{userset.pre_suspend_on_lowbg_option}}</td>
                <td class="td3"></td>
              </tr>
            </table>
          </div>
        </div>
      </div>

      <div class="part">
        <div class="tit1e">
          <span>&nbsp;{{$t('t1222_Auto_Mode')}}</span>
        </div>

<!--        <div class="statics" style="margin-top: 30px;">-->

<!--          <div class="statics" style="margin-top: 30px;">-->
<!--            &lt;!&ndash;<p>{{$t('pdm')}}</p>&ndash;&gt;-->
<!--            <table class="statics-table">-->
<!--              <tr>-->
<!--                <td class="td3">{{$t('Low Suspend')}}: {{userset.suspend_on_lowbg_option_app}}</td>-->
<!--                <td class="td3">{{$t('Predictive Low Suspend')}}:  {{userset.pre_suspend_on_lowbg_option}}</td>-->
<!--                <td class="td3"></td>-->
<!--              </tr>-->
<!--            </table>-->
<!--          </div>-->
<!--        </div>-->

        <div class="statics" style="margin-top: 30px;">
          <!--<p style="float: left">{{$t('CGM')}}</p>-->
          <div class="spe-text">
            <p>{{$t('t1222_Auto_Mode')}}:  {{userset.auto_basal.autobasalflag}}</p>

          </div>
          <div class="statics" style="clear: both">

            <table class="statics-table">
              <tr>
                <td class="td1">{{$t('t1029_Target_SG')}}: {{userset.auto_basal.BGTarget}}</td>

                <td class="td1">{{$t('t1029_Auto_Meal_Handling')}}: {{userset.auto_basal.nFoodFlag}}</td>

                <td class="td1">{{$t('weight')}}: {{userset.auto_basal.AutoBasalWeight}} kg </td>
              </tr>

              <tr>
                <td class="td3">{{$t('t1029_Total_Daily_Dose')}}: {{userset.auto_basal.AutoBasalTDD}} U</td>

                <td class="td3"></td>
                <td class="td3"></td>
              </tr>
            </table>
          </div>
        </div>

      </div>


    </div>
    <div v-if="showEasyPatch ==='easysense'">
      <div class="part">
        <div class="tit1e">
          <span>&nbsp;{{$t('CGM')}}</span>
        </div>

        <div class="statics" style="margin-top: 30px;">

          <!--<div class="spe-text">
            <p>{{$t('Glucose Alerts')}}:  {{cgm.sensor_alarm_option}}</p>
            <p>{{$t('Alert Silence')}}:  {{cgm.alarm_silent_option}}</p>
          </div>-->

          <div class="statics" style="margin-top: 30px;">
            <!--<p>{{$t('pdm')}}</p>-->
            <table class="statics-table">
              <tr>
                <td class="td1">{{$t('t1108_Transmitter_SN')}}: {{tranSN}}</td>
                <td class="td1">{{$t('Sensor Expiration')}}:{{userset.sensor_expire_option}}</td>
                <td class="td2">{{$t('Glucose Alerts')}}: {{cgm.sensor_alarm_option}}</td>
              </tr>
              <tr>
                <td class="td3">{{$t('t1102_Factory_Calibration')}}: {{$t(userset.factory_calibration_option)}}</td>
                <td class="td3"></td>
                <td class="td3"></td>
              </tr>
            </table>
          </div>

          <div class="statics" style="clear: both">
            <p class="custom">{{$t('Glucose Limits')}}</p>
            <table class="statics-table">
              <tr>
                <td class="td1">{{$t('From')}}</td><td v-for="i in cgmLimit" class="td1">{{i[0]}}</td><td class="td1">--</td><td class="td1">--</td><td class="td2">--</td>
              </tr>
              <tr>
                <td class="td1">{{$t('Low')}}</td><td v-for="i in cgmLimit" class="td1">{{i[1]}}</td><td class="td1">--</td><td class="td1">--</td><td class="td2">--</td>
              </tr>
              <tr>
                <td class="td3">{{$t('High')}}</td><td v-for="i in cgmLimit" class="td3">{{i[2]}}</td><td class="td3">--</td><td class="td3">--</td><td>--</td>
              </tr>
            </table>
          </div>
        </div>
        <div class="table-group-wrap1">
          <div class="statics small-table">
            <p class="custom" style="float: left">{{$t('Predicitive Alerts')}} (hh:mm)</p>
            <table class="statics-table">
              <tr>
                <td class="td1">{{$t('high1')}}</td>
                <td class="td1">{{cgm.sensor_forecast_alarm.high[0]}}</td>
                <td class="td2">{{cgm.sensor_forecast_alarm.high[1]}}</td>
              </tr>
              <tr>
                <td class="td3">{{$t('low1')}}</td>
                <td class="td3">{{cgm.sensor_forecast_alarm.low[0]}}</td>
                <td>{{cgm.sensor_forecast_alarm.low[1]}}</td>
              </tr>
            </table>
          </div>
          <div class="statics small-table">
            <p class="custom" style="float: left">{{$t('Rate Alerts')}} ({{unit1}}/min)</p>
            <table class="statics-table">
              <tr>
                <td class="td1">{{$t('Rise')}}</td>
                <td class="td1">{{cgm.sensor_rate_alarm.rise[0]}}</td>
                <td class="td2">{{cgm.sensor_rate_alarm.rise[1]}}</td>
              </tr>
              <tr>
                <td class="td3">{{$t('Fall')}}</td>
                <td class="td3">{{cgm.sensor_rate_alarm.fall[0]}}</td>
                <td>{{cgm.sensor_rate_alarm.fall[1]}}</td>
              </tr>
            </table>
          </div>
          <div style="clear:both;"></div>
        </div>

        <div class="table-group-wrap1" v-if="false">
          <div class="statics small-table">
            <p class="custom" style="float: left">{{$t('t1102_Alerts_for_Low')}} </p>
            <table class="statics-table">
              <tr>
                <td class="td1">{{$t('Repeat')}}</td>
                <td class="td2">{{cgm.easypatch_cgm_alerts_low_repeat}}</td>
              </tr>
              <tr>
                <td class="td1">{{$t('Snooze')}}</td>
                <td class="td2">{{cgm.easypatch_cgm_alerts_low_snooze}}</td>
              </tr>
              <tr>
                <td class="td3">{{$t('t1112_Tone')}}</td>
                <td>{{cgm.easypatch_cgm_alerts_low_tone}}</td>
              </tr>
            </table>
          </div>
          <div class="statics small-table">
            <p class="custom" style="float: left">{{$t('t1102_Alerts_for_High')}} </p>
            <table class="statics-table">
              <tr>
                <td class="td1">{{$t('Repeat')}}</td>
                <td class="td2">{{cgm.easypatch_cgm_alerts_high_repeat}}</td>
              </tr>
              <tr>
                <td class="td1">{{$t('Snooze')}}</td>
                <td class="td2">{{cgm.easypatch_cgm_alerts_high_snooze}}</td>
              </tr>
              <tr>
                <td class="td3">{{$t('t1112_Tone')}}</td>
                <td>{{cgm.easypatch_cgm_alerts_high_tone}}</td>
              </tr>
            </table>
          </div>
          <div class="statics small-table">
            <p class="custom" style="float: left">{{$t('t1102_Alerts_for_Others')}}</p>
            <table class="statics-table">
              <tr>
                <td class="td1">{{$t('Repeat')}}</td>
                <td class="td2">{{cgm.easypatch_cgm_alerts_other_repeat}}</td>
              </tr>
              <tr>
                <td class="td1">{{$t('Snooze')}}</td>
                <td class="td2">{{cgm.easypatch_cgm_alerts_other_snooze}}</td>
              </tr>
              <tr>
                <td class="td3">{{$t('t1112_Tone')}}</td>
                <td>{{cgm.easypatch_cgm_alerts_other_tone}}</td>
              </tr>
            </table>
          </div>

          <div class="statics small-table">
            <p class="custom" style="float: left">{{$t('t1029_Alerts_for_Hypo')}} </p>
            <table class="statics-table">
              <tr>
                <td class="td3">{{$t('t1112_Tone')}}</td>
                <td>{{cgm.easypatch_cgm_alerts_hypo_tone}}</td>
              </tr>
            </table>
          </div>

          <div style="clear:both;"></div>
        </div>
      </div>

      <div class="part">
        <div class="tit1e">
          <span>&nbsp;{{$t('APP')}}</span>
        </div>

        <div class="statics" style="margin-top: 30px;">

          <div class="statics" style="margin-top: 30px;">
            <!--<p>{{$t('pdm')}}</p>-->
            <table class="statics-table">
              <tr>
                <td class="td1">{{$t('Name')}}: {{userset.user_name}}</td>
                <td class="td1">{{$t('Audio Options')}}: {{userset.alarm_type}}</td>
                <td class="td2">{{$t('Glucose Unit')}}: {{userset.glucose_unit}}</td>
              </tr>
              <tr>
                <td class="td3">{{$t('t1112_Weight_Unit')}}: {{userset.easypatch_weight_unit}}</td>
                <td class="td3">{{$t('t1112_Height_Unit')}}: {{userset.easypatch_height_unit}}</td>
                <td class="td3"></td>
              </tr>
            </table>
          </div>

        </div>

      </div>
    </div>
    <!--对话框-->
    <el-dialog  :visible.sync="typeChooseVisible" :size=dialogSize id="dialog-form2" :show-close="false">
      <div slot="title" class="patientList-dialog-title">
        <span>{{$t('DeviceSetting')}}</span>
        <img src="../../assets/cancel.png" @click="cancel">
      </div>
      <div slot class="dialog-body">
        <div class="time-range">
          <p style="margin-right:35%;">{{$t('time')}}</p>
          <p>{{$t('Source')}}</p>
        </div>
        <hr class="patientList-small-hr">
        <table class="pdm" id="pdm">
          <tr v-for="(item,index) in PDM">
            <td class="select">
            <!--<label @click="choose" :id="index"></label>-->
              <label @click="choose" :id="item[0]" :class="{'no':item[0]==tempSelectId}"></label>
            </td>
            <td>{{item[1]}}</td>
            <td>{{item[2]}}</td>
          </tr>
        </table>
        <div class="patientList-block">
          <img src="../../assets/chart6-icon/arrow_right_m.png" :class="{'click1': !has_prev}" @click="prevPage">
          <span> <input v-model="page" @keyup.13="go" @blur='go'> of &nbsp;&nbsp;{{pages}}</span>
          <img src="../../assets/chart6-icon/arrow_left_m.png" :class="{'click1': !has_next}" @click="nextPage">
        </div>
        <hr class="patientList-small-hr">
      </div>
      <div slot="footer" class="dialog-footer">
        <button @click="apply">{{$t('Apply')}}</button>
        <button  class="cancelButton" @click="cancel">{{$t('Cancel')}}</button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import * as echarts from 'echarts'
  import auth from '../../auth/auth'
  import format from '@/lib/format'
  import B64 from '../../auth/base64'
  import {loading} from '../mixins/loading'
  export default{
    mixins: [loading],
    data() {
      return {
        pumpSN:'--',tranSN:'--',
        easypatch_reminder:[],
        showEasyPatch:'',    // 是否显示
        unit1:'',
        chartWidth: '', timer: false,typeChooseVisible:false, value1:'',isC:false, flag:0,count:0, sta:'',end:'',Average:[],unit:'',isMg:'',unit2:"",
        chartColumn: null, startDate:'',  timeRange:'',defaultDate:'',whichDay:' EverDay', weekmode:'yyyyyyy',isEn:false,isPo:false,
        date:[true,true,true,true,true,true,true],dialogSize:'tiny',isEs:false,
        hours:['00:00','01:00','02:00','03:00','04:00','05:00','06:00','07:00','08:00','09:00','10:00',
          '11:00','12:00','13:00','14:00','15:00','16:00','17:00','18:00','19:00','20:00','21:00','22:00','23:00'],
        hours2:['08:00','10:00','12:00','13:00','19:00','20:00','21:00'],
        repeat:['once','once','once','once','once','once','once',],max_bolus_length:0,
        selectId:0,
        tempSelectId:0,
        page:1,pages:5,has_next:'',has_prev:'',PDM:[],time:'',rid:0,
        chart6_1:null,chart6_2:null,chart6_3:null,chart6_4:null,chart6_5:null,maxBolOption:'',
        chart6_6:null,chart6_7:null,chart6_8:null,

        IcRatio:[],ins_sen:[],bg_target:[],max_bolus:[],cgmLimit:[], uid:0, isA:true,index:0,first:true,

        textStyle: {
          color: '#282828',
          fontWeight: 'normal',
          fontSize: '14',
          fontFamily: 'SFUIText-Regular'
        },
        titlePadding: [0, 0, 8, 30],
        grid: {x: '3%', y: '15%', width: '95.5%', height: '68%'},
        yAxisLabel: {interval: 0, margin: 5, textStyle: {color: '#282828', baseline: 'middle'}, showMinLabel: false},
        xLabel:['18-07-2017','19-07-2017','20-07-2017','21-07-2017','22-07-2017','23-07-2017','24-07-2017','25-07-2017',
          '26-07-2017','27-07-2017','28-07-2017','29-07-2017','30-07-2017','31-07-2017'],

        basal:{
          "basal_onoff": "--",
          "basal_select": "--",
          "max_rate":'--',
          "exer_basal": {
            "day_total": '--',
            "seg": []
          }
        },
        exeBasal:[],standBasal:[],holidayBasal:[],programA:[],programB:[],sgMax:4,
        sickBasal:[],programC:[],programD:[],  // fm018新增3种基础量。

        standardSeg:[], standardSeg1:[],standardSeg2:[], standardSeg3:[],standardSeg4:[],
        exerSeg:[], exerSeg1:[],exerSeg2:[], exerSeg3:[],exerSeg4:[],
        holidaySeg:[], holidaySeg1:[],holidaySeg2:[], holidaySeg3:[],holidaySeg4:[],
        programASeg:[], programASeg1:[],programASeg2:[], programASeg3:[],programASeg4:[],
        programBSeg:[], programBSeg1:[],programBSeg2:[], programBSeg3:[],programBSeg4:[],

        // fm018新增3种基础量。
        sickSeg:[], sickSeg1:[], sickSeg2:[], sickSeg3:[],sickSeg4:[],
        programCSeg:[], programCSeg1:[],programCSeg2:[], programCSeg3:[],programCSeg4:[],
        programDSeg:[], programDSeg1:[],programDSeg2:[], programDSeg3:[],programDSeg4:[],
        axisMaxArr:[],
        moreBasal:true,

        basalInfo:[{}, {}, {}, {}, {}, {}, {}, {}],

        bolus:{
          "bg_reminder": "--",
          "bg_target": [],
          "bolus_reminder": [],
          "bolus_step": '--',
          "bolus_wizard": "--",
          "extent_option": "--",
          "ins_active_time": '--',
          "ins_carb_ratio": [],
          "ins_sen": [],
          "max_bolus": '--'
        },
        //IcRatio:[],ins_sen:[],bg_target:[],bolus_rem:[],cgmLimit:[],
        bolus_rem:[],
        cgm:{
          "alarm_silent_option": "--",
          "sensor_alarm_option": "--",
          "sensor_alarm_repeat": {
            "high": [
              "--",
              "--"
            ],
            "low": [
              "--",
              "--"
            ]
          },
          "sensor_alarm_settings": {
            "auto_calib_option": "--",
            "calib_remind_interval": "--",
            "calib_remind_option": "--",
            "calib_remind_time": "--",
            "no_calib_display": "--",
            "sensor_lost_time": '--',
            "trend_time_scope": '--'
          },
          "sensor_alarm_threshold": [],
          "sensor_forecast_alarm": {
            "high": [
              "--",
              "--"
            ],
            "low": [
              "--",
              "--"
            ]
          },
          "sensor_rate_alarm": {
            "fall": [
              "--",
              '--'
            ],
            "rise": [
              "--",
              '--'
            ]
          }
        },
        userset:{
            "user_name":"--",
          "alarm_type": "--",
          "auto_off_option": "--",
          "auto_off_time": "--",
          "backlight_timeout":"--",
          "beep_off_tip_interval": "--",
          "beep_off_tip_option":"--",
          "cgms_module_flag": "--",
          "clock": [],
          "clock_option": "--",
          "cmd_response": "--",
          "day_bolus_max": "--",
          "device_option": "--",
          "glucose_unit": "--",
          "hour_bolus_max": "--",
          "keypad_lock": "--",
          "low_reservoir_ins": "--",
          "low_reservoir_time": "--",
          "low_reservoir_type": "--",
          "password_option": "--",
          "patch_expire_ahead": "--",
          "patch_expire_alarm": "--",
          "pre_suspend_on_lowbg_level": "--",
          "pre_suspend_on_lowbg_option": "--",
          "pump_module_flag":"--",
          "screen_timeout": "--",
          "suspend_on_lowbg_level": "--",
          "suspend_on_lowbg_option": "--",
          "sensor_expire_option":"--",
          "time_style": "--",
          "pump_sn":"--",
          "sensor_sn":"--",
          auto_basal:{}
        },
      }
    },
    methods:{
      getPdm1(){
        let param = {
            page:this.page,
            flag:'web'
        };
        console.log('12312param',param)
        auth.getPdm1(this,this.uid,param);
      },
      getAxisMax(seg) {
        let valArr=seg.map(function(e,i){
          return e[1];
        });
        let maxVal = Math.max.apply(null, valArr);
        let axisMax = (parseInt(maxVal/2)+1) * 2;
        return axisMax;
      },
      getOptionText(optionVal) {
        let optionText='--'
        if (1==optionVal) {
          optionText = this.$t('Off')
        } else if (2==optionVal) {
          optionText = this.$t('On')
        }
        return optionText;
      },
      getPdm2(){
        this.isA = false;
        this.exeBasal=[];this.standBasal=[];this.holidayBasal=[];this.programA=[];this.programB=[];
        this.sickBasal=[];this.programC=[];this.programD=[];
        let rid =parseInt(sessionStorage.getItem('rid'));
        console.log('getPdm2.1:', rid);
        if(rid===0){
          rid = this.PDM[0][0];
        }
        let param = {
          gu:(this.isMg)?'mg/dL':'mmol/L',
        };
        let ins_unit2=this.$t('ins_unit2')
        param = B64.base64encode(JSON.stringify(param));
        this.$http.get('api/v2.0/pdm/'+this.uid+'/settings/'+rid,{params:{param}}).then(function (res) {
          let err =res.body.error;
          //console.log('device setting:', res.body);
          this.typeChooseVisible=false;
          if(err === 0){
            let data = res.data.settings;
            // console.log('device setting:', JSON.stringify(res.data));
            data.pdm_version_str=res.data.pdm_version_str;
            data.device_type=res.data.device_type;
            let device_type=res.data.device_type;
            if (18 == res.data.device_type) {
              this.moreBasal=true;
              this.showEasyPatch='PDM';
            } else if ('easypatch'==device_type) {
              this.moreBasal=true;
              this.showEasyPatch='easypatch';
            } else if ('easysense'==device_type){
              this.moreBasal=false;
              this.showEasyPatch='easysense';
            } else{
              this.moreBasal=false;
              this.showEasyPatch='PDM';
            }
            if (this.moreBasal) {
              this.basalInfo=[{}, {}, {}, {}, {}, {}, {}, {}];
            }

            /*if ('easypatch'==device_type) {
              this.showEasyPatch=true;
            } else {
              this.showEasyPatch=false;
            }*/
            //
            sessionStorage.setItem('deviceSet',JSON.stringify(data));
            if(data.basal_settings){
              this.exeBasal = auth.getPdmSG(data.basal_settings.exer_basal.seg);
              this.standBasal = auth.getPdmSG(data.basal_settings.stand_basal.seg);
              this.holidayBasal = auth.getPdmSG(data.basal_settings.holiday_basal.seg);
              this.programA = auth.getPdmSG(data.basal_settings.program_a_basal.seg);
              this.programB = auth.getPdmSG(data.basal_settings.program_b_basal.seg);
              this.axisMaxArr[0] = this.getAxisMax(data.basal_settings.stand_basal.seg)
              this.axisMaxArr[1] = this.getAxisMax(data.basal_settings.exer_basal.seg)
              this.axisMaxArr[2] = this.getAxisMax(data.basal_settings.holiday_basal.seg)
              this.axisMaxArr[3] = this.getAxisMax(data.basal_settings.program_a_basal.seg)
              this.axisMaxArr[4] = this.getAxisMax(data.basal_settings.program_b_basal.seg)

              if (this.moreBasal) {
                console.log('data.basal_settings.program_c_basal.seg: ', data.basal_settings.program_c_basal.seg)
                this.programC = auth.getPdmSG(data.basal_settings.program_c_basal.seg);
                this.programD = auth.getPdmSG(data.basal_settings.program_d_basal.seg);
                this.sickBasal = auth.getPdmSG(data.basal_settings.sick_basal.seg);

                //
                this.axisMaxArr[5] = this.getAxisMax(data.basal_settings.program_c_basal.seg)
                this.axisMaxArr[6] = this.getAxisMax(data.basal_settings.program_d_basal.seg)
                this.axisMaxArr[7] = this.getAxisMax(data.basal_settings.sick_basal.seg)
              }



              this.basal = data.basal_settings;
              this.basal.max_rate = (this.basal.max_rate)?this.basal.max_rate.toFixed(2)+this.$t('basal_unit2'):'--';
              // basalInfo
              this.basalInfo[0].total=this.basal.stand_basal.day_total.toFixed(2);;
              this.basalInfo[0].title=this.$t('Standard');
              this.standardSeg=this.basal.stand_basal.seg;

              this.basalInfo[1].total=this.basal.exer_basal.day_total.toFixed(2);;
              this.basalInfo[1].title=this.$t('Exercise');
              this.exerSeg=this.basal.exer_basal.seg;

              this.basalInfo[2].total=this.basal.holiday_basal.day_total.toFixed(2);;
              this.basalInfo[2].title=this.$t('Holiday');
              this.holidaySeg=this.basal.holiday_basal.seg;

              this.basalInfo[3].total=this.basal.program_a_basal.day_total.toFixed(2);;
              this.basalInfo[3].title=this.$t('ProgramA');
              this.programASeg=this.basal.program_a_basal.seg;

              this.basalInfo[4].total=this.basal.program_b_basal.day_total.toFixed(2);;
              this.basalInfo[4].title=this.$t('ProgramB');
              this.programBSeg=this.basal.program_b_basal.seg;

              if (this.moreBasal){
                this.basalInfo[5].total=this.basal.program_c_basal.day_total.toFixed(2);;
                this.basalInfo[5].title=this.$t('t1028_Pattern_C');
                this.programCSeg=this.basal.program_c_basal.seg;

                this.basalInfo[6].total=this.basal.program_d_basal.day_total.toFixed(2);;
                this.basalInfo[6].title=this.$t('t1028_Pattern_D');
                this.programDSeg=this.basal.program_d_basal.seg;

                this.basalInfo[7].total=this.basal.sick_basal.day_total.toFixed(2);;
                this.basalInfo[7].title=this.$t('t1029_Sick');
                this.sickSeg=this.basal.sick_basal.seg;
              } else {
                this.basalInfo.splice(5,3);
              }

              var segName= ['standardSeg', 'exerSeg', 'holidaySeg', 'programASeg', 'programBSeg',
                'programCSeg', 'programDSeg', 'sickSeg'];
              if (!this.moreBasal) {
                segName.splice(5,3);
              }

              for (let n=0; n<segName.length; n++) {
                this.basalInfo[n].bsg1=[];
                this.basalInfo[n].bsg2=[];
                this.basalInfo[n].bsg3=[];
                this.basalInfo[n].bsg4=[];

                this.basalInfo[n].bsg2show=false;
                this.basalInfo[n].bsg3show=false;
                this.basalInfo[n].bsg4show=false;
              }

              for (let n=0; n<segName.length; n++) {
                let curSeg=this[segName[n]];
                curSeg=curSeg.map(function(e, i){
                  return [e[0],e[1].toFixed(2)];
                });

                for(let i =0;i<curSeg.length;i++){
                  if(i<12){
                    this[segName[n]+'1'].push(curSeg[i])
                    this.basalInfo[n].bsg1.push(curSeg[i]);
                  }
                  else if(i<24){
                    this[segName[n]+'2'].push(curSeg[i])
                    this.basalInfo[n].bsg2.push(curSeg[i]);
                    this.basalInfo[n].bsg2show=true;
                  }
                  else if(i<36){
                    this[segName[n]+'3'].push(curSeg[i])
                    this.basalInfo[n].bsg3.push(curSeg[i]);
                    this.basalInfo[n].bsg3show=true;
                  }
                  else{
                    this[segName[n]+'4'].push(curSeg[i])
                    this.basalInfo[n].bsg4.push(curSeg[i]);
                    this.basalInfo[n].bsg4show=true;
                  }
                }
              }
            }
            if(data.bolus_settings){
               data.bolus_settings.max_bolus = (data.bolus_settings.max_bolus)?data.bolus_settings.max_bolus+ins_unit2:'--';
              data.bolus_settings.bolus_step = (data.bolus_settings.bolus_step)?data.bolus_settings.bolus_step+ins_unit2:'--';
              data.bolus_settings.ins_active_time = (data.bolus_settings.ins_active_time)?data.bolus_settings.ins_active_time+'H':'--';
              this.bolus = data.bolus_settings;
              this.cgm = data.sensor_settings;
            if(this.cgm.sensor_rate_alarm){
              this.cgm.sensor_rate_alarm.fall[1] = (this.cgm.sensor_rate_alarm.fall[0]!=="Off")?this.cgm.sensor_rate_alarm.fall[1].toFixed(3):'--';
              this.cgm.sensor_rate_alarm.rise[1] = (this.cgm.sensor_rate_alarm.rise[0]!=="Off")?this.cgm.sensor_rate_alarm.rise[1].toFixed(3):'--';
            }
            if(this.cgm.sensor_alarm_repeat){
              this.cgm.sensor_alarm_repeat.high[1] = (this.cgm.sensor_alarm_repeat.high[0]!=="Off")? this.cgm.sensor_alarm_repeat.high[1]:'--';
              this.cgm.sensor_alarm_repeat.low[1] = (this.cgm.sensor_alarm_repeat.low[0]!=="Off")? this.cgm.sensor_alarm_repeat.low[1]:'--';
            }
            if(this.cgm.sensor_forecast_alarm){
              this.cgm.sensor_forecast_alarm.high[1] = (this.cgm.sensor_forecast_alarm.high[0]!=="Off")? this.cgm.sensor_forecast_alarm.high[1]:'--';
              this.cgm.sensor_forecast_alarm.low[1] = (this.cgm.sensor_forecast_alarm.low[0]!=="Off")? this.cgm.sensor_forecast_alarm.low[1]:'--';
            }
            this.cgm.sensor_alarm_settings.calib_remind_time = (this.cgm.sensor_alarm_settings.calib_remind_option.toUpperCase()!='OFF')?this.cgm.sensor_alarm_settings.calib_remind_time:"--";
            this.cgm.sensor_alarm_settings.calib_remind_interval = (this.cgm.sensor_alarm_settings.auto_calib_option.toUpperCase()!='OFF')?this.cgm.sensor_alarm_settings.calib_remind_interval:"--";

            this.userset = data.user_settings;
            this.unit2 = this.userset.glucose_unit;
            this.userset.sensor_sn = (this.userset.sensor_sn)?this.userset.sensor_sn:'--';
            this.tranSN = auth.deviceSNFormat(this.userset.sensor_sn, 'TRANS');
            this.userset.user_name = (this.userset.user_name)?this.userset.user_name:'--';
            this.userset.sensor_expire_option = (this.userset.sensor_expire_option)?this.$t(this.userset.sensor_expire_option):'--';
            this.userset.pump_sn = (this.userset.pump_sn)?this.userset.pump_sn:'--';
            this.pumpSN = auth.deviceSNFormat(this.userset.pump_sn, 'PUMP');
            this.userset.alarm_type = (this.userset.alarm_type)?this.$t(this.userset.alarm_type):'--';
            this.userset.low_reservoir_time = (this.userset.low_reservoir_type==='time')?this.userset.low_reservoir_time:this.$t(this.userset.low_reservoir_type)+' '+this.userset.low_reservoir_ins+ins_unit2;
            let opt = this.userset.patch_expire_alarm;
            this.userset.patch_expire_alarm = (opt==='On')?this.$t(opt)+' '+this.userset.patch_expire_ahead+'H':this.$t(opt);
            this.userset.auto_off_option = (this.userset.auto_off_option==='On')?this.$t(this.userset.auto_off_option)+' '+this.userset.auto_off_time+'H':this.$t(this.userset.auto_off_option);
            this.userset.pre_suspend_on_lowbg_option = (this.userset.pre_suspend_on_lowbg_option==='On')?this.$t(this.userset.pre_suspend_on_lowbg_option)+' '+this.userset.pre_suspend_on_lowbg_level+' min':this.$t(this.userset.pre_suspend_on_lowbg_option);
            if ('On'==this.userset.out_of_range_option) {
              function time_format(minute){

                if (minute<60) {
                  return minute+'min';
                } else if (0==(minute%60)) {
                  return Math.floor(minute/60) + 'h';
                } else {
                  return Math.floor(minute/60) + 'h ' + (minute%60) + 'min';
                }
              }
              this.userset.out_of_range_option = this.$t('On')+' ' + time_format(this.userset.out_of_range_time);
            } else if ('Off'==this.userset.out_of_range_option) {
              this.userset.out_of_range_option = this.$t('Off');
            } else {
              this.userset.out_of_range_option = '--';
            }

            if (!this.userset.telephone) {
              this.userset.telephone = '--'
            }

            if(this.userset.clock){
                let that =this;
                this.userset.clock.map(function (e,i) {
                   e[1] = that.$t(e[1]);
                })
            }
            this.userset.suspend_on_lowbg_option =this.$t( this.userset.suspend_on_lowbg_option);
            if( this.userset.suspend_on_lowbg_option===this.$t('On')){
              this.userset.suspend_on_lowbg_level =(this.isMg)?parseInt(this.userset.suspend_on_lowbg_level):this.userset.suspend_on_lowbg_level.toFixed(1);
              this.userset.suspend_on_lowbg_option_app =this.userset.suspend_on_lowbg_option;
              //this.userset.suspend_on_lowbg_option =this.userset.suspend_on_lowbg_option+' '+this.userset.suspend_on_lowbg_level+this.unit;
            }
            // 自动模式相关的设置
            if (this.userset.auto_basal) {
              let auto_basal=this.userset.auto_basal;
              // if (1==auto_basal.autobasalflag) {
              //   auto_basal.autobasalflag = this.$t('Off')
              // } else if (2==auto_basal.autobasalflag) {
              //   auto_basal.autobasalflag = this.$t('On')
              // }
              let auto_basal_option=auto_basal.autobasalflag;
              auto_basal.autobasalflag = this.getOptionText(auto_basal.autobasalflag);

              //if ('mg/dL' == this.userset.glucose_unit) {
              if (this.isMg) {
                if (0==auto_basal.BGTarget) {
                  auto_basal.BGTarget = '100 mg/dL'
                } else if (1==auto_basal.BGTarget) {
                  auto_basal.BGTarget = '110 mg/dL'
                } else if (2==auto_basal.BGTarget) {
                  auto_basal.BGTarget = '120 mg/dL'
                }
              } else {
                if (0==auto_basal.BGTarget) {
                  auto_basal.BGTarget = '5.6 mmol/L'
                } else if (1==auto_basal.BGTarget) {
                  auto_basal.BGTarget = '6.1 mmol/L'
                } else if (2==auto_basal.BGTarget) {
                  auto_basal.BGTarget = '6.7 mmol/L'
                }
              }

              auto_basal.nFoodFlag = this.getOptionText(auto_basal.nFoodFlag);
              if (!auto_basal.AutoBasalWeight) {
                auto_basal.AutoBasalWeight='--';
              }
              if (!auto_basal.AutoBasalTDD) {
                auto_basal.AutoBasalTDD='--';
              }
              //
            } else {
              this.userset.auto_basal={
                autobasalflag:'Off',
                BGTarget:'--',
                nFoodFlag:'--',
                AutoBasalWeight:'--',
                AutoBasalTDD:'--'
              };
            }
            //this.IcRatio = auth.getRatio(this,data.bolus_settings.ins_carb_ratio,2);
            //this.ins_sen = auth.getRatio(this,data.bolus_settings.ins_sen,0);
            //this.bg_target = auth.getRatio(this,data.bolus_settings.bg_target,1);
            this.IcRatio = data.bolus_settings.ins_carb_ratio;
            this.ins_sen = data.bolus_settings.ins_sen;
            this.bg_target = data.bolus_settings.bg_target;
            this.bolus_rem = data.bolus_settings.bolus_reminder;

            //data.bolus_settings.bolus_reminder = [["01:00","02:00"],["02:00","02:30"],["03:00","03:30"]]
            this.max_bolus = auth.getMaxBolus(data.bolus_settings.bolus_reminder);
           // console.log(data.bolus_settings.bolus_reminder,this.max_bolus)
            this.max_bolus_length = data.bolus_settings.bolus_reminder.length;
            this.initRatio();
            if(this.max_bolus_length>0){
                //this.makeRatio();
            }
            let option = this.$t(data.bolus_settings.bolus_reminder_option);
            this.maxBolOption = ' ('+option+ ')';
            //this.cgmLimit = auth.getGlucoseLimit(this,data.sensor_settings.sensor_alarm_threshold);
            this.cgmLimit = data.sensor_settings.sensor_alarm_threshold;

            this.userset.clock.map(function (e,i) {
              let time = auth.getTime2(e[0]);
              e[0] = time[0]+":"+time[1];
              return e;
            });
            if (this.userset.clock.length) {
              this.userset.clock_option='on';
            } else {
              this.userset.clock_option='off';
            }

            let basal_select_map = {
              'ProgramC':'t1028_Pattern_C',
              'ProgramD':'t1028_Pattern_D',
              'Sick':'t1029_Sick',
            }
            if (basal_select_map[this.basal.basal_select]) {
              this.basal.basal_select = basal_select_map[this.basal.basal_select];
            }

            this.basal.basal_select = this.$t(this.basal.basal_select);
            this.basal.basal_onoff = this.$t(this.basal.basal_onoff);
            this.bolus.bg_reminder = this.$t(this.bolus.bg_reminder);
            this.bolus.extent_option = this.$t(this.bolus.extent_option);
            this.bolus.bolus_wizard = this.$t(this.bolus.bolus_wizard);
            this.userset.cgms_module_flag = this.$t(this.userset.cgms_module_flag);
            this.userset.cmd_response = this.$t(this.userset.cmd_response);
            this.userset.clock_option = this.$t(this.userset.clock_option);
            this.userset.pump_module_flag = this.$t(this.userset.pump_module_flag);

            this.cgm.sensor_rate_alarm.fall[0] =this.$t(this.cgm.sensor_rate_alarm.fall[0]);
            this.cgm.sensor_rate_alarm.rise[0] =this.$t(this.cgm.sensor_rate_alarm.rise[0]);
            this.cgm.sensor_alarm_repeat.high[0] =this.$t(this.cgm.sensor_alarm_repeat.high[0]);
            this.cgm.sensor_alarm_repeat.low[0] =this.$t(this.cgm.sensor_alarm_repeat.low[0]);
            this.cgm.sensor_forecast_alarm.high[0] =this.$t(this.cgm.sensor_forecast_alarm.high[0]);
            this.cgm.sensor_forecast_alarm.low[0] =this.$t(this.cgm.sensor_forecast_alarm.low[0]);
            this.cgm.sensor_alarm_settings.calib_remind_option = this.$t(this.cgm.sensor_alarm_settings.calib_remind_option);
            this.cgm.sensor_alarm_option = this.$t(this.cgm.sensor_alarm_option);
            this.cgm.alarm_silent_option = this.$t(this.cgm.alarm_silent_option);
            }
            if(this.showEasyPatch==='easysense'){
              this.cgm.sensor_forecast_alarm.high[0]= (data.SensorAlarmSetting[5]!==1&&data.SensorAlarmSetting[5]!==true)?'Off':'On'
              this.cgm.sensor_forecast_alarm.high[1] = (data.SensorAlarmSetting[5]===1||data.SensorAlarmSetting[5]===true)? data.SensorAlarmSetting[6]:'--';
              this.cgm.sensor_forecast_alarm.low[0]= (data.SensorAlarmSetting[7]!==1&&data.SensorAlarmSetting[7]!==true)?'Off':'On'
              this.cgm.sensor_forecast_alarm.low[1] = (data.SensorAlarmSetting[7]===1||data.SensorAlarmSetting[7]===true)? data.SensorAlarmSetting[8]:'--';
              this.cgm.sensor_forecast_alarm.high[0] =this.$t(this.cgm.sensor_forecast_alarm.high[0]);
              this.cgm.sensor_forecast_alarm.low[0] =this.$t(this.cgm.sensor_forecast_alarm.low[0]);

              this.cgm.sensor_rate_alarm.fall[0] = (data.SensorAlarmSetting[1]!==1&&data.SensorAlarmSetting[1]!==true)?'Off':'On'
              this.cgm.sensor_rate_alarm.rise[0] = (data.SensorAlarmSetting[3]!==1&&data.SensorAlarmSetting[3]!==true)?'Off':'On'
              this.cgm.sensor_rate_alarm.fall[1] = (this.cgm.sensor_rate_alarm.fall[0]!=="Off")?data.SensorAlarmSetting[2].toFixed(3):'--';
              this.cgm.sensor_rate_alarm.rise[1] = (this.cgm.sensor_rate_alarm.rise[0]!=="Off")?data.SensorAlarmSetting[4].toFixed(3):'--';
              this.cgm.sensor_rate_alarm.fall[0] =this.$t(this.cgm.sensor_rate_alarm.fall[0]);
              this.cgm.sensor_rate_alarm.rise[0] =this.$t(this.cgm.sensor_rate_alarm.rise[0]);

              this.cgm.easypatch_cgm_alerts_low_repeat =data.GlucoseSettings.AlarmLowRepeat
              this.cgm.easypatch_cgm_alerts_low_snooze =data.GlucoseSettings.AlarmLowSnooze
              this.cgm.easypatch_cgm_alerts_low_tone =data.GlucoseSettings.AlarmLowTone

              this.cgm.easypatch_cgm_alerts_high_repeat =data.GlucoseSettings.AlarmHighRepeat
              this.cgm.easypatch_cgm_alerts_high_snooze = data.GlucoseSettings.AlarmHighSnooze
              this.cgm.easypatch_cgm_alerts_high_tone =data.GlucoseSettings.AlarmHighTone

              this.cgm.easypatch_cgm_alerts_other_repeat =data.GlucoseSettings.AlarmRepeat
              this.cgm.easypatch_cgm_alerts_other_snooze =data.GlucoseSettings.AlarmSnooze
              this.cgm.easypatch_cgm_alerts_other_tone =data.GlucoseSettings.AlarmTone

              this.userset.glucose_unit =(data.UnitGlucose === 1)?'mmol/L':'mg/dL'
              this.userset.easypatch_height_unit =(data.UnitHeight === 1)?'cm':''
              this.userset.easypatch_weight_unit =(data.UnitWeight === 1)?'kg':''
              let str =''
              if((data.GeneralAlarmSetting[0]===1&&data.GeneralAlarmSetting[1]!==1)||(data.GeneralAlarmSetting[0]===true&&data.GeneralAlarmSetting[1]!==true)){
                str='Sound'
              }else if((data.GeneralAlarmSetting[0]!==1&&data.GeneralAlarmSetting[1]===1)||(data.GeneralAlarmSetting[0]!==true&&data.GeneralAlarmSetting[1]===true)){
                str ='Vibrate'
              }else if((data.GeneralAlarmSetting[0]===1&&data.GeneralAlarmSetting[1]===1)||(data.GeneralAlarmSetting[0]===true&&data.GeneralAlarmSetting[1]===true)){
                str ='Sound+Vibrate'
              }
              this.userset.alarm_type =this.$t(str)
              let ar1 =data.SensorAlarmSetting.splice(10)
              let resule =[]
              for(let i=0;i<ar1.length;i+=3){
                  resule.push(ar1.slice(i,i+3))
              }
              for(let j=0;j<resule.length;j++){
                resule[j][0] =this.ChangeHourMinutestr(resule[j][0])
                if ('mg/dL' !== this.userset.glucose_unit){
                  resule[j][1] =Number(resule[j][1]/18).toFixed(1)
                  resule[j][2] =Number(resule[j][2]/18).toFixed(1)
                }
              }
              this.cgmLimit =resule 
              console.log('da',resule)
              this.userset.sensor_expire_option =(data.SensorAlarmOverdueEnabled)?'On':'Off'
              this.userset.factory_calibration_option=(data.SensorCodeEnable)?'On':'Off'
              this.cgm.sensor_alarm_option = (data.SensorAlarmSetting[0]!==1&&data.SensorAlarmSetting[0]!==true)?'Off':'On'
              this.cgm.sensor_alarm_option = this.$t(this.cgm.sensor_alarm_option);
              this.tranSN =auth.deviceSNFormat(data.sensor_sn, "TRANS");
              this.cgm.easypatch_cgm_alerts_low_tone = this.cgm
                .easypatch_cgm_alerts_low_tone
                ? this.cgm.easypatch_cgm_alerts_low_tone.split(".")[0]
                : this.cgm.easypatch_cgm_alerts_low_tone;
              this.cgm.easypatch_cgm_alerts_high_tone = this.cgm
                .easypatch_cgm_alerts_high_tone
                ? this.cgm.easypatch_cgm_alerts_high_tone.split(".")[0]
                : this.cgm.easypatch_cgm_alerts_high_tone;
              this.cgm.easypatch_cgm_alerts_other_tone = this.cgm
                .easypatch_cgm_alerts_other_tone
                ? this.cgm.easypatch_cgm_alerts_other_tone.split(".")[0]
                : this.cgm.easypatch_cgm_alerts_other_tone;
              this.cgm.easypatch_cgm_alerts_hypo_tone = this.cgm
                .easypatch_cgm_alerts_hypo_tone
                ? this.cgm.easypatch_cgm_alerts_hypo_tone.split(".")[0]
                : this.cgm.easypatch_cgm_alerts_hypo_tone;
                // app数据
                this.userset.glucose_unit =(data.UnitGlucose === 1)?'mmol/L':'mg/dL'
                this.userset.easypatch_height_unit =(data.UnitHeight === 1)?'cm':'ft'
                this.userset.easypatch_weight_unit =(data.UnitWeight === 1)?'kg':'lb'
                this.userset.user_name =data.user_name
                this.cgm.sensor_forecast_alarm.high[1] = (data.SensorAlarmSetting[5]===1||data.SensorAlarmSetting[5]===true)? this.ChangeHourMinutestr(data.SensorAlarmSetting[6]):'--';
                this.cgm.sensor_forecast_alarm.low[1] = (data.SensorAlarmSetting[7]===1||data.SensorAlarmSetting[7]===true)? this.ChangeHourMinutestr(data.SensorAlarmSetting[8]):'--';
                if ('mg/dL' == this.userset.glucose_unit){
                  this.cgm.sensor_rate_alarm.fall[1] = (this.cgm.sensor_rate_alarm.fall[0]!=="Off")?data.SensorAlarmSetting[4].toFixed(3):'--';
                  this.cgm.sensor_rate_alarm.rise[1] = (this.cgm.sensor_rate_alarm.rise[0]!=="Off")?data.SensorAlarmSetting[2].toFixed(3):'--';
                }else{
                  
                  this.cgm.sensor_rate_alarm.fall[1] = (this.cgm.sensor_rate_alarm.fall[0]!=="Off")?(data.SensorAlarmSetting[4]/1800).toFixed(3):'--';
                  this.cgm.sensor_rate_alarm.rise[1] = (this.cgm.sensor_rate_alarm.rise[0]!=="Off")?(data.SensorAlarmSetting[2]/1800).toFixed(3):'--';
                } 
            }
           
            

           // console.log(data.bolus_settings.bolus_reminder);
            if(this.chart6_1){
                 this.chart6_1.dispose();
            }
            if(this.chart6_2){
              this.chart6_2.dispose();
            }
            if(this.chart6_3){
              this.chart6_3.dispose();
            }
            if(this.chart6_4){
              this.chart6_4.dispose();
            }
            if(this.chart6_5){
              this.chart6_5.dispose();
            }

            //if (this.moreBasal) {
            if (true) {
              if(this.chart6_6){
                this.chart6_6.dispose();
              }
              if(this.chart6_7){
                this.chart6_7.dispose();
              }
              if(this.chart6_8){
                this.chart6_8.dispose();
              }
            }
            this.drawCharts();
          }
        },function(err){
          //alert(err+","+err.body.message);
          //alert();
          alert('error!');
        });
      },

      cancel(){
        this.typeChooseVisible=false;
      },
      open(){
        this.tempSelectId=this.selectId;
        this.typeChooseVisible=true;
      },
      nextPage(){
        if(this.page<this.pages){
          this.page++;
          this.getPdm1();
        }
      },
      prevPage(){
        if(this.page>1){
          this.page--;
          this.getPdm1();
        }
      },
      go(){
        if(0<this.page&&this.page<this.pages+1){
          this.getPdm1();
        }else{
          this.page = 1;
          this.getPdm1();
        }
      },
      choose(e){
        //return;
        sessionStorage.setItem('chart6page',this.page)
        const parent = document.getElementById('pdm');
        const labels =parent.getElementsByTagName('label');
        console.log('choose.1:', e.target.id);
        this.tempSelectId=e.target.id;
        //return;
        if(e.target.className===''){
          for(let i=0;i<labels.length;i++){
              if(e.target===labels[i]){
                e.target.className = 'no';
                this.index = e.target.id;
              }else{
                labels[i].className = '';
              }
          }
        }else{
          e.target.className = '';
        }
      },
      apply(){
        console.log('apply.1:', this.index,this.tempSelectId);
        let selectPdmSN='';
        let preTime = sessionStorage.getItem('time6')
        this.selectId=this.tempSelectId;
        if (this.selectId){
          console.log('apply.2:', this.index);
          for (let i=0; i<this.PDM.length; i++){
            let record=this.PDM[i];
            if (record[0]==this.selectId){
              this.rid=record[0];
              this.time=record[1]+', '+record[2];
              this.index=i;
              selectPdmSN=record[2];
              break;
            }
            let index  = this.index;
          }
          sessionStorage.setItem('time6',this.time);
          sessionStorage.setItem('rid',this.rid);
          sessionStorage.setItem('pdmSN',selectPdmSN);
          if(this.index==='0'){
            let that=this;
          }
          this.getPdm2();
        }else{
          this.typeChooseVisible=false;
        }
        if(preTime !== this.time){
          this.$emit('reload')
        }
      },

      drawChart6_1(chartId, basalPattern, chartTitle, axisMax) {
        let basal_unit2=this.$t('basal_unit2');
        this[chartId] = echarts.init(document.getElementById(chartId));
        this.registLoading(chartId,this[chartId])
        this[chartId].setOption({
            title: {
              text: chartTitle +' '+this.$t('basal_unit'),
              //text: this.$t('basal') +' (U/H)',
              textStyle: this.textStyle,
              padding: this.titlePadding,
            },
            tooltip:{
              trigger:'axis',
              axisPointer:{type:'line', lineStyle:{color:'#333',}},
              backgroundColor:'#333',
              textStyle:{
                color: '#ffffff',
              },
              formatter:function(params){
                let date = new Date(params[0].value[0]);
                let time = format.formatterDate5(date);
                let icon  =" <div style='background: #00ff4c;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
                let timeDetail = time[0] + ':' + time[1] +'<br>';
                return  timeDetail+icon+'Basal: '+params[0].value[1].toFixed(2)+basal_unit2;
              },
            },
            xAxis: [{
              type: 'time',
              boundaryGap: false,
              min:new Date(new Date().setHours(0,0,0,0)),
              max:new Date(new Date().setHours(0,0,0,0)+86400000),
              axisLine: {lineStyle: {color: '#ccc'}},
              splitNumber: 24,
              splitLine: {
                show: true,
                lineStyle: {
                    color: ['#ccc'],
                    type: 'solid'
                    }
                },
              axisLabel:{
                showMaxLabel: true,
                margin: 20, textStyle: {color: '#282828', baseline: 'middle'} ,
                formatter:function (value,index) {
                  // let H = new Date(value).getHours();
                  // index = H;
                  let zero_hour=new Date();
                  zero_hour.setHours(0,0,0,0);
                  index = (value - zero_hour.getTime()) / 3600000;
                  let H=index;
                  if(index<24){
                    if(index%3===0){
                      H = H<10 ? ('0'+H+':00' ): H+':00';
                      return  H;
                    }else{
                      return ' ';
                    }
                  }else{
                    return  '24:00';
                  }
                }
              },
            }],
            yAxis: [{
              type: 'value',
              min:0,
              //max:this.sgMax,
              //max:8,
              max:axisMax,
              axisLabel: this.yAxisLabel,
              axisLine: {lineStyle: {color: '#ccc'}},
              boundaryGap: false,
              axisTick: {length: 0},
              splitLine:{show:true},
              splitNumber:2,
            }],
            grid: this.grid,
            series: [
              {
                type:'line',
                step:'end',
                data: basalPattern,
                itemStyle: {normal: {color:'#0e0',}},
                symbolSize:1
              }
              /*
              {
                type:'line',
                data:this.standBasal,
                itemStyle: {normal: {color:'#0e0',}},
                symbolSize:1,
                tooltip:{backgroundColor:'#333',
                  formatter:function(params){
                    let date = params.value[0];
                    let time = format.formatterDate5(date);
                    return  time[0]+':'+time[1]+', '+params.value[1];
                  },
                },
              },
              {
                type:'line',
                data:this.holidayBasal,
                itemStyle: {normal: {
                  color:'#0e0',
                }},
                symbolSize:1,
                tooltip:{backgroundColor:'#333',
                  formatter:function(params){
                    let date = params.value[0];
                    let time = format.formatterDate5(date);
                    return  time[0]+':'+time[1]+', '+params.value[1];
                  },
                },
              },
              {
                type:'line',
                data:this.programA,
                itemStyle: {normal: {
                  color:'#0e0',
                }},
                symbolSize:1,
                tooltip:{backgroundColor:'#333',
                  formatter:function(params){
                    let date = params.value[0];
                    let time = format.formatterDate5(date);
                    return  time[0]+':'+time[1]+', '+params.value[1];
                  },
                },
              },
              {
                type:'line',
                data:this.programB,
                itemStyle: {normal: {
                  color:'#0e0',
                }},
                symbolSize:1,
                tooltip:{backgroundColor:'#333',
                  formatter:function(params){
                    let date = params.value[0];
                    let time = format.formatterDate5(date);
                    return  time[0]+':'+time[1]+', '+params.value[1];
                  },
                },
              }, */
            ],
          });
      },
      drawLine(){
        let canvas = document.getElementById('canvas');
        if(canvas){
          let context = canvas.getContext('2d');
          context.strokeStyle = '#d3d3d3';
          context.lineWidth = '1px';
          context.beginPath();
          context.moveTo(0,0);
          context.lineTo(95,36);
          context.stroke();
        }
      },
      drawLine2(){
        let canvas2 = document.getElementById('canvas2');
        if(canvas2){
          let context = canvas2.getContext('2d');
          context.strokeStyle = '#d3d3d3';
          context.lineWidth = '1px';
          context.beginPath();
          context.moveTo(0,0);
          context.lineTo(95,46);
          context.stroke();
        }
      },
      handleResize(){
        let win = window.innerWidth;
        let scale = (win<1500)?0.91:0.62;
        const chartWidth = win * scale * 0.98 * 0.90 + 'px';
        let chart6_1 = document.getElementById('chart6_1');
        if(chart6_1 ){
          chart6_1.style.width = chartWidth;
        }

        let chart6_2 = document.getElementById('chart6_2');
        if(chart6_2 ){
          chart6_2.style.width = chartWidth;
        }

        let chart6_3 = document.getElementById('chart6_3');
        if(chart6_3 ){
          chart6_3.style.width = chartWidth;
        }

        let chart6_4 = document.getElementById('chart6_4');
        if(chart6_4 ){
          chart6_4.style.width = chartWidth;
        }

        let chart6_5 = document.getElementById('chart6_5');
        if(chart6_5 ){
          chart6_5.style.width = chartWidth;
        }

        //if (this.moreBasal) {
        if (true) {
          let chart6_6 = document.getElementById('chart6_6');
          console.log('chart6_6:', chart6_6);
          if(chart6_6 ){
            chart6_6.style.width = chartWidth;
          }
          let chart6_7 = document.getElementById('chart6_7');
          if(chart6_7 ){
            chart6_7.style.width = chartWidth;
          }
          let chart6_8 = document.getElementById('chart6_8');
          if(chart6_8 ){
            chart6_8.style.width = chartWidth;
          }
        }
      },
      ChangeHourMinutestr(str) {
        if (str !== "0" && str !== "" && str !== null) {
          return ((Math.floor(str / 60)).toString().length < 2 ? "0" + (Math.floor(str / 60)).toString() : 
          (Math.floor(str / 60)).toString()) + ":" + ((str % 60).toString().length < 2 ? "0" + (str % 60).toString() : (str % 60).toString());
        }else{
          return "";
        }
      },
      drawCharts(){
        //this.drawLine();
        //this.drawLine2();
        this.drawChart6_1('chart6_1', this.standBasal, this.$t('Standard'), this.axisMaxArr[0]);
        this.drawChart6_1('chart6_2', this.exeBasal, this.$t('Exercise'), this.axisMaxArr[1]);
        this.drawChart6_1('chart6_3', this.holidayBasal, this.$t('Holiday'), this.axisMaxArr[2]);
        this.drawChart6_1('chart6_4', this.programA, this.$t('ProgramA'), this.axisMaxArr[3]);
        this.drawChart6_1('chart6_5', this.programB, this.$t('ProgramB'), this.axisMaxArr[4]);
        if (this.moreBasal) {
          this.drawChart6_1('chart6_6', this.programC, this.$t('t1028_Pattern_C'), this.axisMaxArr[5]);
          this.drawChart6_1('chart6_7', this.programD, this.$t('t1028_Pattern_D'), this.axisMaxArr[6]);
          this.drawChart6_1('chart6_8', this.sickBasal, this.$t('t1029_Sick'), this.axisMaxArr[7]);
        }
      },
      print(){
        if(sessionStorage.getItem('rid')){
          console.log('dse.print.1');
          let src1 = this.chart6_1.getDataURL();
          sessionStorage.setItem('src6_1',src1);

          console.log('dse.print.2');
          let src2 = this.chart6_2.getDataURL();
          sessionStorage.setItem('src6_2',src2);

          console.log('dse.print.3');
          let src3 = this.chart6_3.getDataURL();
          sessionStorage.setItem('src6_3',src3);

          console.log('dse.print.4');
          let src4 = this.chart6_4.getDataURL();
          sessionStorage.setItem('src6_4',src4);

          console.log('dse.print.5');
          let src5 = this.chart6_5.getDataURL();
          sessionStorage.setItem('src6_5',src5);

          if (this.chart6_6) {
            console.log('dse.print.6:', this.chart6_6);
            let src6 = this.chart6_6.getDataURL();
            sessionStorage.setItem('src6_6',src6);

            console.log('dse.print.7');
            let src7 = this.chart6_7.getDataURL();
            sessionStorage.setItem('src6_7',src7);

            console.log('dse.print.8');
            let src8 = this.chart6_8.getDataURL();
            sessionStorage.setItem('src6_8',src8);
          }

          window.open('/#/chart6-print','_blank');
        }else{
          let tip = this.$t('chooseDataTip');
          this.$message({
            type: 'warning',
            message: tip
          });
        }
      },
      print2(){
        if(sessionStorage.getItem('rid')){
          let src1 = this.chart6_1.getDataURL();
          sessionStorage.setItem('src6_1',src1);

          let src2 = this.chart6_2.getDataURL();
          sessionStorage.setItem('src6_2',src2);

          let src3 = this.chart6_3.getDataURL();
          sessionStorage.setItem('src6_3',src3);

          let src4 = this.chart6_4.getDataURL();
          sessionStorage.setItem('src6_4',src4);

          let src5 = this.chart6_5.getDataURL();
          sessionStorage.setItem('src6_5',src5);

          let src6 = this.chart6_6.getDataURL();
          sessionStorage.setItem('src6_6',src6);

          let src7 = this.chart6_7.getDataURL();
          sessionStorage.setItem('src6_7',src7);

          let src8 = this.chart6_8.getDataURL();
          sessionStorage.setItem('src6_8',src8);

          window.open('/#/chart6-print2','_blank');
        }else{
          let tip = this.$t('chooseDataTip');
          this.$message({
            type: 'warning',
            message: tip
          });
        }
      },
      makeRatio(){
          return;
          let tr = document.getElementById('maxBolus');
          let Ratio = this.max_bolus;
          for(let i=0;i<Ratio.length;i++){
              if(Ratio[i].length===2){
                  for(let j=1;j<Ratio[i][1]+1;j++){
                    let td = tr.getElementsByTagName('td')[Ratio[i][0]+j];
                    td.style.backgroundColor = '#add9ff';
                    td.style.borderLeft = 'none';
                    if(j!==Ratio[i][1]){
                      td.style.borderRight = 'none';
                    }
                  }
              }
          }
      },
      initRatio(){
        /*
        let tr = document.getElementById('maxBolus');
        let td = tr.getElementsByTagName('td');
        let length = td.length;
        for(let j=1;j<length;j++){
          td[j].style.backgroundColor = '#fff';
          td[j].style.borderRight = '1px solid #d3d3d3';
          td[j].style.borderLeft = '1px solid #d3d3d3';
        }*/
      }
    },
    mounted: function () {
      let lang = sessionStorage.getItem('language');
      this.isEn = (lang!=='zh'&&lang !=='hk')?true:false;
      this.isPo = (lang==='po')?true:false;
      this.isEs = (lang==='es')?true:false;
      this.isMg = (localStorage.getItem('unit')==='mg')?true:false;
      this.unit = (this.isMg)?'mg/dL':'mmol/L';
      this.unit1 = (this.isMg)?'mg/dL':'mmol/L';
      if(sessionStorage.getItem('userType')!=='P'){
        this.uid = parseInt(sessionStorage.getItem('patientId'));
      }else{
        this.uid = parseInt(sessionStorage.getItem('uid'));
      }
      this.page =sessionStorage.getItem('chart6page')
      if(!this.page){
        this.page =1
      }
      auth.getPdm1(this,this.uid, {
        page:this.page,
        flag:'web'
      });

      if(sessionStorage.getItem('rid')){
         // this.time = sessionStorage.getItem('time6');
        //  this.getPdm2();
      }
      let that = this;
      /**/
      //this.drawCharts();
      let win = window.innerWidth;
      this.dialogSize =(win<1500)?'small':'tiny';
      window.onresize = function () {
        that.handleResize();
        if( that.chart6_1){
          that.chart6_1.resize();
        }
        if( that.chart6_2){
          that.chart6_2.resize();
        }
        if( that.chart6_3){
          that.chart6_3.resize();
        }
        if( that.chart6_4){
          that.chart6_4.resize();
        }
        if( that.chart6_5){
          that.chart6_5.resize();
        }

        //if (this.moreBasal) {
        if (true) {
          if( that.chart6_6){
            that.chart6_6.resize();
          }
          if( that.chart6_7){
            that.chart6_7.resize();
          }
          if( that.chart6_8){
            that.chart6_8.resize();
          }
        }
      }
    }
  }
</script>

<style scoped>
  .chart-container {
    width:100%;
    float: left;
    font-family:SFUIText-Regular;
    font-size:14px;
    color:#282828;
    letter-spacing:-0.34px;
  }
  .Hcp-main-header{
    width:97%;
    height:40px;
    margin:0 auto;
    font-family:SFUIText-Regular;
    font-size:18px;
    color:#282828;
  }
  .main-header-left{
    float: left;
    height:20px;
    line-height: 20px;
    margin-top:10px;
    border-left: 2px solid #005dac;
  }
  .main-header-left span{
    margin-left:10px;
  }
  .main-header-right{
    float: right;
    width:60%;
    height:30px;
    line-height: 30px;
    margin-right: 1%;
  }
  .main-header-right p{
    float: right;
    margin-right:15px;
    margin-top:2px;
  }
  .main-header-right .time{
    font-size:16px;
    letter-spacing:-0.39px;
    color:#0082d2;
    margin-left: 10px;
  }
  .main-header-right button{
    float: right;
    border-radius:100px;
    box-shadow:0 3px 4px 0 #e8f3ff;
    background: #fff;
    border: 1px solid #a3a3a3;
    width:110px;
    height:26px;
    line-height: 26px;
    outline: none;
    margin-top:4px;
    margin-left: 3%;
    cursor: pointer;
  }
  button:hover{
    background-image:linear-gradient(90deg, #42c3fd 0%, #55adf8 100%);
    color:#fff;
  }
  .main-header-right .set{
    margin-left: 0;
  }
  button span{
    font-family:SFUIText-Regular;
    font-size: 16px;
    letter-spacing:-0.39px;
  }
  .small-hr{
    background:#e6e8ea;
    width:97%;
    height:1px;
    margin:10px auto 20px;
    border:none;
  }


  .chart-container .part{
    width:96%;
    margin:0 auto 40px;
    font-family:SFUIText-Regular;
    font-size:18px;
    color:#282828;
    letter-spacing:-0.43px;
  }
  .spe-hr{
    width: 100%;
    margin-bottom: 15px;
  }
  .tit1e{
    height: 23px;
    line-height: 23px;
  }
  .tit1e span {
    border-left:2px solid #009fdf;
    *font-size:12px;
  }
  .part img{
    margin-right: 10px;
    display: block;
    float: left;
  }
  .label{
    width:100%;
    text-align: left;
    margin-bottom: 15px;
  }
  .label span{
    margin-right: 4%;
  }
  .labe2 span{
    margin-right: 3%;
  }
  .spe-label2 span{
    margin-right: 4.7%;
  }
  .po3 span{
    margin-right: 3.7%;
  }
  .label .spe-span2{
    margin-right: 0;
  }
  .es13 span{
    margin-right: 2.2%;
  }
  .label label{
    color:#0082d2;
  }
  .spe-label{
    margin-bottom: 8px;
  }
  .spe-label span{
    display:block;
    margin:0;
  }
  .spe-label .left{
    float: left;

  }
  .spe-label .right{
    float: right;
  }
  .spe-label .center{
    width: 35%;
    margin-left:40%;
  }

  .chart-container .graph {
    width:960px;
    height: 160px;
    margin-bottom: 15px;
    margin-left: -2%;
  }

  .table1,.table2{
    width:102%;
    table-layout: fixed;
    height:210px;
    margin-left: -1%;
    border:1px solid #919191;
    font-family:SFUIText-Regular;
    font-size:13px;
    color:#282828;
    letter-spacing:-0.29px;
    line-height:13px;
    border-collapse:collapse;
    text-align: center;
  }
  .table1 .header,.table2 .header{
    height:36px;
    width: 95px;
    position: relative;
  }
  .table1{
    word-wrap: break-word;
    word-break: break-all;
  }
  .table1 .first{
    height:42px;
    width: 95px;
  }
  .table1 td,.table2 td{
    border:1px solid #d3d3d3;
  }
  .table1 .span1{
    position: absolute;
    top:17px;
    left:15px;
  }
  .table1 .span2{
    position: absolute;
    top:7px;
    left:60px;
  }

  .table2{
    height:124px;
  }
  .table2 .header{
    height:46px;
  }
  .table2 .span1{
    position: absolute;
    top:32px;
    left:2px;
  }
  .table2 .span2{
    position: absolute;
    top:10px;
    left:58px;
  }
  .table2 .zh2{
    top:28px;
    left:6px;
  }
  .po1{
    text-align: left;
  }
  .table2 .po2{
    top:20px;
    left:1px;
  }

  .chart-container .part1 {
    margin-bottom: 20px;
  }
  .part1 img{
    margin-top: 2px;
  }
  .chart-container .part2 {
    margin:0 auto 40px;
  }
  .part2 .content{
    display: inline-block;
    width:20%;
    margin-right: 6.3%;
    margin-bottom: 10px;
  }
  .part2 .spe-content{
    margin-right: 0;
  }
  .little-table{
    width: 100%;
    height:80px;
    margin-top: 5px;
    border:1px solid #d3d3d3;
    border-collapse: collapse;
    text-align: center;
    font-family:SFUIText-Regular;
    font-size:13px;
    color:#282828;
    letter-spacing:-0.29px;
    line-height:13px;
    margin-left: -6%;
  }
  .little-table td{
    border:1px solid #d3d3d3;
  }
  .little-table .text{
    color:#0082d2;
  }

  .content2,.content3{
    width:101%;
    margin-bottom: 20px;
   }
  .content2 .little-table{
    margin-left: -1%;
    width: auto;
    height:50px;
  }
 .content3 .little-table{
    width:101%;
    margin-left: -1%;
    height: 50px;
  }
  .content3 .text{
    width:10%;
  }



    /*对话框*/
  #dialog-form2{
    font-family:SFUIText-Regular;
  }
  .patientList-dialog-title{
    float: left;
    background-image:linear-gradient(90deg, #38bcf7 0%, #3fa1f4 100%);
    height:45px;
    line-height: 50px;
    width:100%;
    margin:-20px 30px 0 -20px;
    font-size:18px;
    color:#ffffff;
    letter-spacing:-0.43px;
    position: absolute;
  }
  .patientList-dialog-title span{
    margin-left: 42px;
  }
  .patientList-dialog-title img{
    float: right;
    margin-top:16px;
    cursor: pointer;
    margin-right: 10px;
  }
  .dialog-body{
    width:100%;
    margin-top: 10px;
  }
  .patientList-small-hr{
    background:#dedede;
    width:94%;
    height:1px;
    margin:5px 0 10px 10px;
    border:none;
    clear: both;
  }
  .dialog-body .time-range{
    height:35px;
    line-height: 35px;
    text-align: center;
    width: 70%;
    margin:0 auto;
    padding-left: 12%;
  }
  .time-range p{
    display: inline-block;
    font-family:SFUIText-Regular;
    font-size:18px;
    color:#282828;
    letter-spacing:-0.44px;
  }
  .pdm{
    width:70%;
    margin:0 auto;
  }
  .pdm .select{
    width:3%;
    height:25px;
  }
  .pdm td{
    font-family:SFUIText-Regular;
    font-size:16px;
    color:#282828;
    letter-spacing:-0.39px;
    text-align:center;
  }
  .pdm label{
    background: url("../../assets/select no.png") left 1px no-repeat;
    cursor: pointer;
    padding-left: 18px;
  }
  .pdm .no{
    background: url("../../assets/select yes.png") left 1px no-repeat;
  }

  /*分页*/
  .patientList-block{
    height:20px;
    width: 140px;
    margin:20px auto 10px;
    letter-spacing:-0.44px;
  }
  .patientList-block img{
    cursor: pointer;
    float: left;
  }
  .patientList-block span{
    float: left;
    font-family:SFUIText-Regular;
    font-size:16px;
    color:#282828;
    text-align:left;
    margin: -2px 18px 0;
  }
  .patientList-block input{
    float: left;
    font-family:SFUIText-Regular;
    font-size:16px;
    height:16px;
    width:25px;
    margin-right: 10px;
    text-align: center;
    border: 1px solid #aaa;
  }
  .patientList-block .click1{
    opacity: 0.3;
    cursor:auto;
  }

  .dialog-footer{
    margin:-25px auto 15px;
    width:70%;
  }
  .dialog-footer button{
    background-image:linear-gradient(90deg, #42c3fd 0%, #55adf8 100%);
    box-shadow:0 3px 4px 0 #c6e1ff;
    color:#fff;
    margin:0 auto;
    border-radius:100px;
    width:40%;
    height:30px;
    border:none;
    outline: none;
    cursor: pointer;
  }
  .dialog-footer .cancelButton{
    background: transparent;
    border:1px solid #009fdf;
    color: #282828;
    outline: none;
    margin-left: 10%;
  }
  .statics{
    margin-top: 15px;
    margin-bottom: 17px;
  }
  .statics p{
    margin-left: 3%;
    font-family:SFUIText-Regular;
    font-size:15px;
    color:#282828;
    letter-spacing:-0.27px;
    text-align:left;
    padding-left: 3px;
    border-left: 2px solid #009fdf;;
  }
  .statics .custom{
    border:none;
    padding-left: 5px;
    float: left;
  }
  .statics-table{
    width: 98%;
    margin:10px auto 0;
    border:1px solid #747474;
    font-family:SFUIText-Regular;
    font-size: 16px;
    border-collapse: collapse;
    text-align:center;
    table-layout: fixed;
  }
  .statics-table td{
    height:40px;
  }
  .statics-table .td1{
    border-bottom:1px solid rgba(116,116,116,0.34);
    border-right:1px solid rgba(116,116,116,0.34);
  }
  .statics-table .td2{
    border-bottom:1px solid rgba(116,116,116,0.34);
  }
  .statics-table .td3{
    border-right:1px solid rgba(116,116,116,0.34);
  }

  .spe-text{
    float: right;
    min-width: 140px;
    margin-right: 25px;
  }
  .spe-text p{
    border:none;
    float: right;

  }
  .small-table{
    width: 31.6%;
    float: left;
    margin-left: 1%;
    margin-top: -5px;
  }
  .middle-table{
    width: 50%;
    float: left;
    margin-left: 1%;
    margin-top: -5px;
  }
</style>






// WEBPACK FOOTER //
// chart6.vue?75ab33f3